import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function Widerspruch() {
  const { token } = useParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    api
      .get(`/referrals/ablehnen/${token}`)
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A1128] px-6">
      <div className="w-full max-w-md text-center">
        {state === "ok" && (
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="widerspruch-success">
            <CheckCircle size={64} weight="fill" color="#C5A059" className="mx-auto" />
            <h1 className="mt-8 font-display text-4xl font-light tracking-tight text-white">Daten gelöscht</h1>
            <p className="mt-4 text-base leading-relaxed text-white/70">
              Deine Daten wurden entfernt. Es findet keine Kontaktaufnahme statt und es werden keine Daten weiterverarbeitet.
            </p>
          </motion.div>
        )}
        {state === "error" && (
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="widerspruch-error">
            <XCircle size={64} weight="fill" color="#C0392B" className="mx-auto" />
            <h1 className="mt-8 font-display text-4xl font-light tracking-tight text-white">Link ungültig</h1>
            <p className="mt-4 text-base text-white/70">Dieser Link ist nicht mehr gültig oder wurde bereits verarbeitet.</p>
          </motion.div>
        )}
        {state === "loading" && <p className="text-white/60">Einen Moment …</p>}
      </div>
    </div>
  );
}
